import { jwtTokenState } from '../auth.state';
import { useAtomValue } from 'jotai';

export const useAuthorization = () => {
  const jwtToken = useAtomValue(jwtTokenState);
  const isUserAuthorized = !!jwtToken;

  return {
    isUserAuthorized,
  };
};
